/**
 * Базовый URL API. На Cloudflare Pages — same-origin + _redirects (без CORS preflight).
 * Прямой Railway URL из Telegram давал OPTIONS+PUT (~20 с) и обрыв WebView.
 */
export function resolveBackendBase(): string {
  if (String(import.meta.env.VITE_USE_DEV_PROXY ?? '').toLowerCase() === 'true') {
    return '';
  }
  const fromEnv = String(import.meta.env.VITE_BACKEND_URL ?? '').replace(/\/$/, '');
  const forceSame = String(import.meta.env.VITE_API_SAME_ORIGIN ?? '').toLowerCase() === 'true';
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (forceSame || host.endsWith('.pages.dev') || host.endsWith('.vercel.app')) {
      return window.location.origin;
    }
  }
  return fromEnv;
}

export function usesSameOriginApiProxy(): boolean {
  if (typeof window === 'undefined') return false;
  return resolveBackendBase() === window.location.origin;
}
